<nav class="navbar navbar-light bg-light navbar-expand-lg">
  <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent"
    aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>
  <div class="collapse navbar-collapse" id="navbarSupportedContent">
    <form class="form-inline my-2 my-lg-0 ms-3 me-2">
      <input id="busquedaFormControl" type="text" class="form-control" [formControl]="busquedaFormControl"
        placeholder="Factura / Fecha / Cliente" (input)="filtrarFacturas()" />
    </form>
    <ul class="navbar-nav me-auto">
      <!-- desde -->
      <li class="nav-item me-2">
        <div class="input-group">
          <input type="date" [ngModel]="modelDesde" class="fechaFormControlDesdeHasta" placeholder="aaaa-mm-dd"
                 (ngModelChange)="modelDesde = $event" name="dt" ngbDatepicker #d="ngbDatepicker" value="modelDesde"
                 class="form-control form-control-rounded" #searchDate required readonly>
          <div class="input-group-append">
            <button id="botonDesde" type="button" class="input-group-btn btn btn-secondary" (click)="d.toggle()">
              <i class="fa fa-calendar" aria-hidden="true"></i></button>
          </div>
        </div>
      </li>
      <!-- hasta -->
      <li class="nav-item">
        <div class="input-group">
          <input type="date" class="fechaFormControlDesdeHasta" [ngModel]="modelHasta" placeholder="aaaa-mm-dd"
                 name="dp" value="modelHasta" (ngModelChange)="modelHasta = $event" class="form-control form-control-rounded"
                 ngbDatepicker #h="ngbDatepicker" #searchDate required readonly>

          <div class="input-group-append">
            <button id="botonHasta" type="button" class="input-group-btn btn btn-secondary" (click)="h.toggle()"><i
              class="fa fa-calendar" aria-hidden="true"></i></button>
          </div>
        </div>
      </li>
      <li class="nav-item">
        <button (click)="buscarDesdeHasta()" class="btn btn-outline-primary my-2 my-lg-0 mx-lg-2" type="submit"><i
          class="fa fa-search" aria-hidden="true"></i></button>
      </li>
    </ul>
  </div>
</nav>
<div class="col col-md-12">
  <div class="spinner-container" *ngIf="this.loading()">
      <ngx-spinner name="spinnerGrafico" bdOpacity=0.3bd
        Color="rgba(193,193,193,0)" size="medium" color="#185db5" type="ball-grid-beat" [fullScreen]="false">
        <p style="color: white">C a r g a n d o . . . </p>
      </ngx-spinner>
  </div>
  <div class="abs-center" *ngIf="!this.loading() && this.facturasFiltrados.length==0">
    <ngb-alert type="warning"> No se encontraron facturas para solicitar refacturación con litros disponibles.</ngb-alert>
  </div>
  <div class="row mt-3">
    <div class="card-body" *ngIf="!this.loading() && this.facturasFiltrados.length>0" style="max-height: 440px; overflow-y: auto;">
      <table class="table table-striped table-hover">
        <thead class="text-center">
          <tr>
          <td><b>Fecha</b></td>
          <td><b>Factura</b></td>
          <td><b>Tipo</b></td>
          <td><b>Cliente</b></td>
          <td><b>Producto</b></td>
          <td><b>Litros Disponibles</b></td>
          <td><b>Acción</b></td>
          </tr>
        </thead>
        <tbody class="text-center">
          <tr *ngFor="let factura of this.facturasFiltrados let i = index">
            <td>{{ factura.fechaHoraComprobante | date: "d'/'MM'/'y'"}}</td>
            <td>{{ factura.numeroComprobante }}</td>
            <td>{{ factura.tipoComprobante | tipoMovimiento }}</td>
            <td>{{ factura.cliente }} </td>
            <td>{{ factura.producto }} </td>
            <td>{{ factura.litrosDisponibles | number:'0.0-0'}}
            </td>
            <td>
              <button (click)="this.solicitarRefacturacion(factura)"
                class="btn btn-outline-primary my-2 my-lg-0 mx-lg-2">Solicitar Refacturación
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
